/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Type of draw tool
 */

export const DrawToolType = {
    building_annotation: 'building_annotation',
    circle: 'circle',
    erase: 'erase',
    freehand: 'freehand',
    line: 'line',
    move: 'move',
    polygon: 'polygon',
    rectangle: 'rectangle',
    route: 'route',
    ruler: 'ruler',
    select: 'select',
    spot: 'spot',
    symbol: 'symbol',
    tactical_annotation: 'tactical_annotation',
    text: 'text',
    unstyled: 'unstyled',
} as const;

export type DrawToolType = typeof DrawToolType[keyof typeof DrawToolType];



